import { useState } from 'react';
import { useViewMode } from '../context/ViewModeContext';

export default function ViewModeSwitcher() {
  const { mode, setMode } = useViewMode();
  const [open, setOpen] = useState(false);

  const options = [
    { value: 'auto',    label: 'Automatique', icon: '🔄' },
    { value: 'mobile',  label: 'Téléphone',   icon: '📱' },
    { value: 'desktop', label: 'Ordinateur',  icon: '💻' },
  ];

  const current = options.find(o => o.value === mode) || options[0];

  return (
    <div className="relative">
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="flex items-center gap-2 px-3 py-2 rounded-lg bg-gray-100 hover:bg-gray-200 text-gray-700 text-sm font-medium transition"
        title="Changer le mode d'affichage"
      >
        <span>{current.icon}</span>
        <span className="hidden sm:inline">{current.label}</span>
      </button>

      {open && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} />
          <div className="absolute right-0 mt-2 w-48 bg-white rounded-xl shadow-2xl z-50 overflow-hidden border border-gray-100">
            {options.map(opt => (
              <button
                key={opt.value}
                onClick={() => { setMode(opt.value); setOpen(false); }}
                className={`w-full flex items-center gap-3 px-4 py-3 text-left text-sm hover:bg-gray-50 transition ${
                  mode === opt.value
                    ? 'bg-[#F39C12]/10 text-[#F39C12] font-semibold'
                    : 'text-gray-700'
                }`}
              >
                <span className="text-lg">{opt.icon}</span>
                <span>{opt.label}</span>
                {mode === opt.value && <span className="ml-auto">✓</span>}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}